module.exports = __webpack_public_path__ + "img/bulle-payment.bd01d3b0.png";